// extracted by mini-css-extract-plugin
module.exports = {"progress":"FullProgress_progress__z_qxe","progressBar":"FullProgress_progressBar___0H_g","text":"FullProgress_text__fiDd0","noBorder":"FullProgress_noBorder__2k4Kt"};